import classes from "../../purchase.module.scss";
import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";

import { ReactComponent as ArrowUpSvg } from "@/assets/images/desktop/Flechaverdehorizontal.svg";
import { ReactComponent as ArrowDownSvg } from "@/assets/images/desktop/flechaverdeabajo.svg";

import { dateToLocale, formatMiles, initialText } from "@/services/Utils";
import OrdersReturnActionItem from "./Action/OrdersReturnActionItem";
import OrdersReturnTableBodyDetail from "./OrdersReturnTableBodyDetail";

const OrdersReturnTableBody = ({ data, setData, base }) => {
	return (
		<tbody>
			{data &&
				data.map((item, i) => {
					return [
						<tr key={i} className={`${classes.table_tr} ${item.active && classes.thisActive}`}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active} ${classes.first_div}`}>{item.code}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>
									{item && item.created_at && dateToLocale(item.created_at)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>
									<CustomTooltip
										text={item.dealer && item.dealer.name.length < 5 ? item.dealer.name : item.dealer ? initialText(item.dealer.name) : ""}
										description={item.dealer ? item.dealer.name : ""}
									/>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>{item && item.order_sale_id}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>{item && item.order_delivery_id}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`}>
									{item && item.details && formatMiles(item.details.length)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active}`} style={{ position: "relative" }}>
									<OrdersReturnActionItem item={item} indice={i} data={data} setData={setData} base={base} />
								</div>
							</td>
							<td
								onClick={() => {
									let newData = [...data];
									newData.forEach((element, j) => {
										if (!newData[i].active) {
											newData[j].active = false;
										}
									});
									newData[i].active = !newData[i].active;
									setData(newData);
								}}
								className={`${classes.table_td}`}
							>
								<div className={`${classes.table_div} ${item.active && classes.active} ${classes.last_div}`}>
									{item.active ? <ArrowDownSvg /> : <ArrowUpSvg />}
								</div>
							</td>
						</tr>,
						<OrdersReturnTableBodyDetail item={item} key={`detail_${i}`} />,
					];
				})}
		</tbody>
	);
};

export default OrdersReturnTableBody;
